export default __webpack_public_path__ + "static/media/p3.e708bec9.jpg";